'use client';

import React, { useEffect } from "react";
import { loadEventLocationsFlyoutContent } from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/data-access/preload";
import { SlideOutEventLocation } from "@/app/lib/generated/graphql-types";
import FlyoutHeaderTypography
    from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutHeaderTypography";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import { Stack } from "@mui/system";
import LinkButton from "@/app/features/shared/__to_be_integrated/LinkButton";
import FlyoutWrapper from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutWrapper";
import ErrorBox from "@/app/__to_be_integrated/_____components/_NEW/ErrorBox";

export default function EventLocationsFlyoutInfo() {
    const [content, setContent] = React.useState<SlideOutEventLocation>();
    const [error, setError] = React.useState<string | null>(null);

    useEffect(() => {
        (async () => {
            const { data, error } = await loadEventLocationsFlyoutContent();
            if (error || !data) {
                console.error('Error loading event locations flyout content:', error);
                setError('Fehler beim Laden der Inhalte. Bitte versuchen Sie es später erneut.');
                return;
            }

            setContent(data);
        })()
    }, []);

    if (error) return <ErrorBox error={error} />
    if (content === undefined) return null;

    return (
        <FlyoutWrapper
            backgroundImage={content.image}
            hideBackgroundOnMobile={false}
            slots={{
               paper: {
                   sx: {
                       width: { md: '33vw' },
                   }
               }
           }}
        >
            <Stack
                spacing={2}
                sx={(theme) => ({
                    py: 2,
                    textAlign: 'center',
                    [theme.breakpoints.up('md')]: {
                        maxWidth: '33vw',
                        textAlign: 'left',
                    }
                })}
            >
                <FlyoutHeaderTypography>{content.title}</FlyoutHeaderTypography>
                <Markdown value={content.description} />

                <Stack direction="row">
                    {content.links && content.links.filter(link => link !== null).map((link, index) => (
                        <LinkButton key={index} link={link} fullWidth />
                    ))}
                </Stack>
            </Stack>
        </FlyoutWrapper>
    )
}
